import {COLORS} from '@/utils/constants';
import {ISubmissionProps} from '../../resources/submission';
import {IConfigSchema,} from '../../resources/config-schema';
import {getIndicators} from './calculations';

interface IConfigSchemaProps {
    submissions: ISubmissionProps[]
}

export const configSchema = ({submissions}: IConfigSchemaProps): IConfigSchema => ({
    title: 'III. INDICE SINTETICO DI AUTONOMIA DEI BENEFICIARI ACCOMPAGNATI',
    tooltip: 'Il grafico mostra in maniera sintetica il livello di autonomia dei beneficiari accompagnati dal progetto considerando una serie di dimensioni (movimenti, cura e igiene personale, pulizia quotidiana della casa, preparazione dei pasti, spesa e commissioni ricorrenti, gestione dei propri beni)',
    type: 'column',
    categories: ['Percentuale di autonomia dei beneficiari presi in carico'],
    series: [
        {
            color: COLORS.blue,
            name: 'Data',
            data: [getIndicators(submissions)]
        },
    ],
});